"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {addClass, on, removeClass, findAllIn, findIn} from "@elements/dom-utils";

export function init() {
    onFind('.js-prescriber-form', function (form) {
        let select = findIn('.js-prescriber-form__select', form);
        let hiddenInputs = findAllIn('.js-prescriber-form__hidden-input', form);

        console.log(hiddenInputs)
        on('change', e => {
            console.log('change')
            if(select.value === 'true'){
                hiddenInputs.map(function (input) {
                    removeClass('d-none', input);
                });
            }else{
                hiddenInputs.map(function (input) {
                    addClass('d-none', input);
                });
            }
        }, select);

    });
}
